import { render, staticRenderFns } from "./informacion_porcentaje.vue?vue&type=template&id=92571a1c&scoped=true"
import script from "./informacion_porcentaje.vue?vue&type=script&lang=js"
export * from "./informacion_porcentaje.vue?vue&type=script&lang=js"
import style0 from "./informacion_porcentaje.vue?vue&type=style&index=0&id=92571a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92571a1c",
  null
  
)

export default component.exports